module.exports = function (source,lang) {
    return require('./lib/traditionlize_TW')(source,lang)
}
